import React, { useContext } from 'react';
import Context from "../context/context";
import NavItem from './NavItem';
import HiddenSearch from './HiddenSearch';
import Search from './Search';


const FilterNav = props => {
  const {clearAllFilters, toggleFilterNav, viewResults} = props;
  const {language, filterNav} = useContext(Context);

  return (
    <>
      <div className="filter-top">
        <div className="filters-label">
        {language.filter_by}
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6.5L7 1.5L2 6.5" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>
        </div>

      </div>
      <div className="filter-nav">
      {filterNav.map((widget, i) => {
        if (widget.position != "top" && widget.title != "Search"){
          return <NavItem
                    key={i}
                    widget={widget}
                    toggleFilterNav={toggleFilterNav}
                 />
        }
      })}
      </div>
      <div className="filter-bottom">

      <div class="filter-bottom-buttons">
      <button className="view-results" onClick={viewResults}>
        <span>See results</span>
      </button>
      <button className="clear-all-filters" onClick={clearAllFilters}>
        <span>{language.clear_all_filters}</span>
      </button>

      </div>

      </div>
    </>
  )
}

export default FilterNav;
